import { useState, useEffect, forwardRef, useRef, Fragment } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";
import Countdown from 'react-countdown';

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  TextField,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  InputAdornment,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper,
  CircularProgress
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import NumberFormat from 'react-number-format';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const NumberFormatCustom = forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      isNumericString
    />
  );
});

const Completionist = () => <span>Waktu ubah stok telah habis</span>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
  return <span>{days} hari : {hours} jam : {minutes} menit : {seconds} detik</span>;
  }
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: '70%' },
    minHeight: '200px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const PoInvoice = ({
    invoiceData,
    invoiceDataCustom,
    header,
    poData,
    poProgress,
    poForm,
    stokInfo,
    withStok,
    updatedWithStok,
    updatedStokInfo,
    updatedPoForm,
    updatedInvoice,
    rekeningku,
    updatedRekeningku,
    updatedPoData,
    authData,
    loading,
    updatedLoading
}) => {
    const ref = useRef(null);
    const [openingModalPo, setOpeningModalPo] = useState(false);
    const [openModalPo, setOpenModalPo] = useState(false);
    const [openModalPayment, setOpenModalPayment] = useState(false);
    const [openModalPelunasan, setOpenModalLunas] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [valToSubmit, setValToSubmit] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const navigate = useNavigate();
    const params = useParams();

    const [valueTab, setValueTab] = useState(0);
    const handleChangeTab = (event, newValue) => {
      setValueTab(newValue);
    };
    let totalQty = 0;
    let jumlah = 0;
    // const groupedInvoiceData = [];
    const statusPo = invoiceData[0]?.status;

    invoiceData.forEach((value) => {
      jumlah += value.total;
      totalQty += value.jumlah;
    });


    // for (let i = 0; i < 3; i++) {
    //   groupedInvoiceData.push(invoiceData.slice(i, i + 2));
    // }

    console.log(invoiceDataCustom);

    const diskon =
    authData.role === 'distributor'
      ? 35/100 * jumlah
      : authData.role === 'agen'
        ? 25/100 * jumlah
        : authData.role === 'reseller'
          ? 15/100 * jumlah
          : authData.role === 'marketer'
            ? 10/100 * jumlah
            : 0; 
    const labelDiskon =
    authData.role === 'distributor'
      ? '35%'
      : authData.role === 'agen'
        ? '25%'
        : authData.role === 'reseller'
          ? '15%'
          : authData.role === 'marketer'
            ? '10%'
            : '0';

    const totalByr = jumlah - diskon;
    const dppo = 50/100 * totalByr;

    const handleOpenModalPo = (idpoproduk) => {
      setOpenModalPo(true);
    };

    const handleOpenModalPayment = () => {
      setOpenModalPayment(true);
    };

    const handleOpenModalLunas = () => {
      setOpenModalLunas(true);
    };

    const handleCloseModalPo = () => {
      setOpenModalPo(false);
      setOpeningModalPo(false);
      setSubmitting(false);
    };

    const handleCloseModalPayment = () => {
      setOpenModalPayment(false);
    };

    const handleCloseModalPelunasan = () => {
      setOpenModalLunas(false);
    };

    let newEl = {};

    const handleValToSubmit = async (e, el, max = null) => {
      newEl = el;
      if (
        !isNaN(parseInt(e.target.value)) &&
        e.target.value >= 0
      ) {
        
        let mappedPoForm = {};
        const originalForm = JSON.parse(localStorage.getItem('originalPoForm'));
        const prevForm = await poForm.form;
        const index = await poForm.form.indexOf(el, 0);

        newEl[`po_${el.idpodetail}`].value =
        max !== null && parseInt(e.target.value) > max
            ? originalForm.form[index][`po_${el.idpodetail}`].prevStok
            : parseInt(e.target.value);
        newEl[`po_${el.idpodetail}`].total = parseInt(e.target.value) * el.harga;
        
        if (withStok && stokInfo.length > 0) {
          const prevStock = stokInfo.filter((v) => v.idpo === el.idpo)[0];
          const stockIndex = stokInfo.indexOf(prevStock, 0);
          
          stokInfo[stockIndex].stok =
            parseInt(e.target.value) > max
            ? 0
            : stokInfo[stockIndex].stok - (parseInt(e.target.value) - el[`po_${el.idpodetail}`].prevValue);
          
          el[`po_${el.idpodetail}`].prevValue = parseInt(e.target.value);
        }
        prevForm[index] = newEl;
        mappedPoForm.jenis_po = poForm.jenis_po;
        mappedPoForm.form = prevForm;

        updatedPoForm(mappedPoForm);
        setValToSubmit(prevForm.filter((v, index) => 
          v[`po_${v.idpodetail}`].value > 0
        ));
      } else e.preventDefault();
    };

    const handleSubmitPo = (e) => {
      // setSubmitting(true);
      e.preventDefault();
      let sumStok = 0;
      let sum238 = 0;
      const errorStok = [];
      //TODO: create stok error
      if (parseInt(params.idpoproduk) === 238) {
        valToSubmit.forEach((v, i) => {
          sum238 += v[`po_${v.idpodetail}`].value;
        });
      }
      console.log(sum238);
      if (valToSubmit.length === 0) {
        setOpenAlert(true);
        setAlertStatus('warning');
        setAlertMessage('Tidak ada perubahan !');
        setSubmitting(false);
      } else if (sum238 > 6) {
        setOpenAlert(true);
        setAlertStatus('error');
        setAlertMessage('Order maksimum 6 pcs!' );
        setSubmitting(false);
      } else {
        const submitPo = async () => {
          const data = {
            stok: withStok,
            idpoproduk: poData.idpoproduk,
            invoice: poData.invoice,
            data: valToSubmit.map((x, i) => {
              const updatedStock = stokInfo.filter((y) => y.idpo === x.idpo)[0]?.stok;
              return { ...x, stokUpdate: updatedStock }
            })
          };
          try {
              await axios.put(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/update/${poData.idpoproduk}`,
                data,
                {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  }
                }
              );
              await getInvoice(poData.invoice);
              handleCloseModalPo();
              setOpenAlert(true);
              setAlertStatus('success');
              setAlertMessage('Stok telah diubah !');
          } catch (err) {
            console.log(err);
            setOpenModalPo(false);
            setOpeningModalPo(false);
            setSubmitting(false);
            setValToSubmit([]);
          }
        };
        const getInvoice = async (invoice) => {
          try {
              const po = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/invoice/${invoice}`, {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  }
                });

              let number = 0;
              console.log(po.data.result);
              updatedInvoice(po.data.result.map((v) => {
                  number+=1;
                  return { ...v, no: number };
              }));

          } catch (err) {
              console.log(err);
          }
        };
        const getFormPo = async (idpoproduk, invoice) => {
          try {
              const poform = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/update/${idpoproduk}`, {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  },
                  params: {
                      idpoproduk,
                      invoice
                  }
              });

              let arrStok = [];

              if (poform.data.result.jenis_po === "PO dengan Stok") {
                updatedWithStok(true);
                  const mappedStok = poform.data.result.form.map((e) => {
                      return { idpo: e.idpo, namakategori: e.namakategori, stok: e.stok }
                  })
                  arrStok = mappedStok.filter((value, index, self) =>
                      index === self.findIndex((t) => (
                          t.idpo === value.idpo
                      ))
                  );
              }
              await updatedStokInfo(arrStok);
              await updatedPoForm(poform.data.result);

          } catch (err) {
              console.log(err);
          }
        };
        submitPo();
      }
    };

    const handleCloseAlert = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setOpenAlert(false);
    };

    const [valuesNumber, setValuesNumber] = useState('0');
  
    const handleChangeNumber = (event) => {
      setValuesNumber(event.target.value);
    };

    const [openModalRekening, setOpenModalRekening] = useState(false);

    const handleCloseModalRekening = () => setOpenModalRekening(false);
    const handleOpenModalRekening = () => setOpenModalRekening(true);

    const [selectedFile, setSelectedFile] = useState(null);

    return (
        <Container>
          <Snackbar
              open={openAlert}
              autoHideDuration={2500}
              onClose={handleCloseAlert}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              key={'top' + 'center'}
          >
              <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                  {alertMessage}
              </Alert>
          </Snackbar>
          <Modal
              open={openModalRekening}
              onClose={handleCloseModalRekening}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
              <Box sx={modalStyle}>
                  <Formik
                      initialValues={{ bank: null, namapemilik: null, rekening: null }}
                      validate={values => {
                          const errors = {};
                          if (!values.bank) {
                              errors.bank = 'Wajib diisi';
                          }
                          if (!values.namapemilik) {
                              errors.namapemilik = 'Wajib diisi';
                          }
                          if (!values.rekening) {
                              errors.rekening = 'Wajib diisi';
                          }
                          return errors;
                      }}
                      onSubmit={async (values, { setSubmitting }) => {
                          try {
                              await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, values, {
                                  headers: {
                                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                  }
                              });
                              // update states
                              const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, {
                                  headers: {
                                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                  }
                              });
                              setOpenAlert(true);
                              updatedRekeningku(res.data.result);
                              setAlertStatus('success');
                              setAlertMessage('Tambah rekening berhasil');
                              handleCloseModalRekening();
                          } catch (err) {
                              console.log(err);
                              setSubmitting(false);
                          }
                      }}
                  >
                      {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                      }) => (
                      <form onSubmit={handleSubmit}>
                          <Grid container spacing={2}>
                              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                  <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                      Tambah Rekening
                                  </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField
                                      id="outlined-multiline-flexible"
                                      required
                                      fullWidth
                                      label="Nama Bank"
                                      onChange={handleChange}
                                      name="bank"
                                  />
                                  <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                      {errors.bank && touched.bank && errors.bank}
                                  </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField
                                      id="outlined-multiline-flexible"
                                      required
                                      fullWidth
                                      label="Nama Pemilik"
                                      onChange={handleChange}
                                      name="namapemilik"
                                  />
                                  <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                      {errors.namapemilik && touched.namapemilik && errors.namapemilik}
                                  </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField
                                      id="outlined-multiline-flexible"
                                      required
                                      fullWidth
                                      label="Nomor Rekening"
                                      onChange={handleChange}
                                      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                      name="rekening"
                                  />
                                  <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                      {errors.rekening && touched.rekening && errors.rekening}
                                  </Typography>
                              </Grid>
                              <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                  <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                              </Grid>
                          </Grid>
                      </form>
                      )}
                  </Formik>
              </Box>
          </Modal>
          <Modal
            open={openModalPelunasan}
            onClose={handleCloseModalPelunasan}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalStyle}>
              <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ textAlign: 'center' }}>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                          Form Konfirmasi Pelunasan
                      </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Formik
                      initialValues={{ idrek: null, jmlhtransfer: null, metodebayar: null }}
                      validate={values => {
                          const errors = {};
                          return errors;
                      }}
                      onSubmit={async (values, { setSubmitting }) => {
                          const newVal = {
                            invoice: poData.invoice,
                            idpoproduk: poData.idpoproduk,
                            idrek: values.idrek,
                            jmlhtransfer: valuesNumber,
                            metodebayar: values.metodebayar
                          };

                          try {
                              await axios.put(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/bayar/lunas/${poData.invoice}`, newVal, {
                                  headers: {
                                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                  }
                              });

                              const getpo = await axios.get(
                                `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/detail/${poData.idpoproduk}`, {
                                  headers: {
                                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                  }  
                              });
                              updatedPoData(getpo.data.result);

                              setAlertStatus('success');
                              setAlertMessage('Konfirmasi pelunasan berhasil');
                              setOpenAlert(true);
                              handleCloseModalPelunasan();
                          } catch (err) {
                              console.log(err);
                              setSubmitting(false);
                          }
                      }}
                    >
                        {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                        }) => (
                        <form onSubmit={handleSubmit}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                select
                                required
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Rekening Pengirim"
                                onChange={handleChange}
                                name="idrek"
                              >
                                {rekeningku && rekeningku.map((item) => (
                                  <MenuItem value={item.idrek}>
                                    {item.bank} | {item.namapemilik} | {item.rekening}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  label="Jumlah Transfer"
                                  // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*',  min: 0 } }
                                  id="outlined-basic"
                                  variant="outlined"
                                  name="jmlhtransfer"
                                  onChange={handleChangeNumber}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        Rp
                                      </InputAdornment>
                                    ),
                                    inputComponent: NumberFormatCustom
                                }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                select
                                required
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Metode Pembayaran"
                                onChange={handleChange}
                                name="metodebayar"
                              >
                                  <MenuItem value="Mandiri 1300017715213">Mandiri 1300017715213</MenuItem>
                                  <MenuItem value="Muamalat 1100003930">Muamalat 1100003930</MenuItem>
                                  <MenuItem value="Bank Syariah Indonesia (BSI) 7105696706">Bank Syariah Indonesia (BSI) 7105696706</MenuItem>
                                  <MenuItem value="Bank Mandiri 2 1730014595525">Bank Mandiri 2 1730014595525</MenuItem>
                                  <MenuItem value="BRI 114101014094501">BRI 114101014094501</MenuItem>
                                  <MenuItem value="BCA 2230917275">BCA 2230917275</MenuItem> 
                              </TextField>
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                <Button variant="contained" type="submit" disabled={isSubmitting}>Kirim</Button>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    </Formik>
                  </Grid>
                  
              </Grid>
            </Box>
          </Modal>
          <Modal
            open={openModalPayment}
            onClose={handleCloseModalPayment}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalStyle}>
              <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ textAlign: 'center' }}>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                          Form Konfirmasi Pembayaran
                      </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Formik
                      initialValues={{ idrek: null, jmlhtransfer: null, metodebayar: null }}
                      validate={values => {
                          const errors = {};
                          return errors;
                      }}
                      onSubmit={async (values, { setSubmitting }) => {
                          const newVal = {
                            invoice: poData.invoice,
                            idpoproduk: poData.idpoproduk,
                            idrek: values.idrek,
                            jmlhtransfer: valuesNumber,
                            metodebayar: values.metodebayar,
                            foto: selectedFile
                          };

                          try {
                              await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/bayar/dp`,
                                  newVal,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                                      "Content-Type": "multipart/form-data"
                                    }
                                  }
                              );
                              
                              const getpo = await axios.get(
                                `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/detail/${poData.idpoproduk}`, {
                                  headers: {
                                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                  }  
                              });
                              updatedPoData(getpo.data.result);

                              setAlertStatus('success');
                              setAlertMessage('Konfirmasi DP berhasil');
                              setOpenAlert(true);
                              handleCloseModalPayment();
                          } catch (err) {
                              console.log(err);
                              setSubmitting(false);
                          }
                      }}
                    >
                        {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                        }) => (
                        <form onSubmit={handleSubmit}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              {rekeningku.length > 0 ? (
                                <>
                                  <TextField
                                    fullWidth
                                    select
                                    required
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Rekening Pengirim"
                                    onChange={handleChange}
                                    name="idrek"
                                  >
                                    {rekeningku && rekeningku.map((item) => (
                                      <MenuItem value={item.idrek}>
                                        {item.bank} | {item.namapemilik} | {item.rekening}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </>
                              ) : (
                                <div style={{ paddingBottom: '7px' }}>
                                  <Alert
                                    severity="warning"
                                    action={
                                        <Button
                                            variant="contained"
                                            size="small"
                                            color="primary"
                                            onClick={() => handleOpenModalRekening(true)}
                                        >
                                            +tambah
                                        </Button>
                                    }
                                  >
                                    Data rekening belum ditambahkan.
                                  </Alert>
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  label="Jumlah Transfer"
                                  // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*',  min: 0 } }
                                  id="outlined-basic"
                                  variant="outlined"
                                  name="jmlhtransfer"
                                  onChange={handleChangeNumber}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        Rp
                                      </InputAdornment>
                                    ),
                                    inputComponent: NumberFormatCustom
                                }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                select
                                required
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Metode Pembayaran"
                                onChange={handleChange}
                                name="metodebayar"
                              >
                                  <MenuItem value="Mandiri 1300017715213">Mandiri 1300017715213</MenuItem>
                                  <MenuItem value="Muamalat 1100003930">Muamalat 1100003930</MenuItem>
                                  <MenuItem value="Bank Syariah Indonesia (BSI) 7105696706">Bank Syariah Indonesia (BSI) 7105696706</MenuItem>
                                  <MenuItem value="Bank Mandiri 2 1730014595525">Bank Mandiri 2 1730014595525</MenuItem>
                                  <MenuItem value="BRI 114101014094501">BRI 114101014094501</MenuItem>
                                  <MenuItem value="BCA 2230917275">BCA 2230917275</MenuItem> 
                              </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <InputLabel>
                                  Bukti Transfer
                                </InputLabel>
                                <TextField
                                  required
                                  fullWidth
                                  type="file"
                                  accept="image/*"
                                  onChange={(event) => {
                                      setSelectedFile(event.target.files[0]);
                                  }}
                                  name="foto"
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                <Button variant="contained" type="submit" disabled={isSubmitting}>Kirim</Button>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    </Formik>
                  </Grid>
                  
              </Grid>
            </Box>
          </Modal>
          <Modal
            open={openModalPo}
            onClose={handleCloseModalPo}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalStyle}>
              <form onSubmit={handleSubmitPo}>
                  <Grid container spacing={1}>
                      <Grid item xs={12} sx={{ textAlign: 'center' }}>
                          <Typography id="modal-modal-title" variant="h6">
                              Form Ubah Stok
                          </Typography>
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'center' }}>
                          <Typography id="modal-modal-title" variant="subtitle1">
                              {header?.namapo}
                          </Typography>
                      </Grid>
                      {poForm.form === undefined ? (
                        <>
                          <Grid item xs={12} sx={{ textAlign: 'center' }}>
                            <CircularProgress sx={{ marginTop: '10px' }} />
                          </Grid>
                          <Grid item xs={12} sx={{ textAlign: 'center' }}>
                            <Typography variant="subtitle2">Loading form ...</Typography>
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={12} sx={{ textAlign: 'center' }}>
                            <TableContainer component={Paper} sx={{ maxHeight: '57vh' }}>
                                <Table stickyHeader aria-label="sticky table" sx={{ width: '460px' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">Nama Barang</Typography></TableCell>
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">Ubah Qty</Typography></TableCell>
                                            {withStok && (
                                              <TableCell><Typography variant="subtitle2" fontWeight="700">Stok</Typography></TableCell>
                                            )}
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">Satuan</Typography></TableCell>
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">Jumlah</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {poForm.form?.map((el) => (
                                      <TableRow>
                                        <TableCell>{el.no}</TableCell>
                                        <TableCell>
                                          <InputLabel sx={{ whiteSpace: 'normal', minHeight: '42px', fontSize: '13px' }}>
                                            {el.variant}
                                          </InputLabel>
                                        </TableCell>
                                        <TableCell>
                                          {(stokInfo.length > 0)
                                            ? (
                                              <input
                                                type="number"
                                                id={`input-qty-${el.idpodetail}`}
                                                min="0"
                                                max={stokInfo.filter((v) => v.idpo === el.idpo)[0]?.stok + el[`po_${el.idpodetail}`].prevValue}
                                                style={{ fontSize: '16px', maxWidth: '55px', borderColor: 'lightgray' }}
                                                defaultValue={el[`po_${el.idpodetail}`].value}
                                                onChange={(e) => {
                                                  if (e.target.value > stokInfo.filter((v) => v.idpo === el.idpo)[0]?.stok + el[`po_${el.idpodetail}`].prevValue) {
                                                    document.getElementById(`input-qty-${el.idpodetail}`).value = 
                                                      stokInfo.filter((v) => v.idpo === el.idpo)[0]?.stok + el[`po_${el.idpodetail}`].prevValue;
                                                  }
                                                  handleValToSubmit(
                                                    e, el, stokInfo.filter((v) => v.idpo === el.idpo)[0]?.stok + el[`po_${el.idpodetail}`].prevValue
                                                  )
                                                }}
                                              />
                                            ) : (
                                              <input
                                                type="number"
                                                id={`input-qty-${el.idpodetail}`}
                                                min="0"
                                                style={{ fontSize: '16px', maxWidth: '55px', borderColor: 'lightgray' }}
                                                defaultValue={el[`po_${el.idpodetail}`].value}
                                                onChange={(e) => {
                                                  handleValToSubmit(
                                                    e, el
                                                  )
                                                }}
                                              />
                                            )}
                                        </TableCell>
                                        {withStok && (
                                          <TableCell>
                                            {stokInfo.filter((v) => v.idpo === el.idpo)[0]?.stok}
                                          </TableCell>
                                        )}
                                        <TableCell>
                                          Rp {el.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </TableCell>
                                        <TableCell>
                                          Rp {el[`po_${el.idpodetail}`].total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                          </Grid>
                          <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                              <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                          </Grid>
                        </>
                      )}
                  </Grid>
              </form>
            </Box>
          </Modal>
            <Grid container>
              <Grid item xs={12} align="center">
                <Typography variant="h5">Sales Invoice</Typography>
              </Grid>
              <Grid item xs={12} align="center">
                <Typography variant="h6">{header?.namapo}</Typography>
              </Grid>
              <Grid item xs={12} align="left">
                <Typography variant="subtitle2">Nama Mitra : {header?.namamitra}</Typography>
              </Grid>
              <Grid item xs={12} align="left">
                <Typography variant="subtitle2">Alamat : {header?.alamat}</Typography>
              </Grid>
              <Grid item xs={12} align="left">
                <Typography variant="subtitle2">Invoice : {header?.invoice}</Typography>
              </Grid>
            </Grid>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={valueTab} onChange={handleChangeTab} aria-label="basic tabs example">
                  <Tab label="Info Invoice" {...a11yProps(0)} />
                  <Tab label="Info Progress" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <TabPanel value={valueTab} index={0}>
                <Grid container>
                  <Grid item xs={12}>
                    <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                      <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 640 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                                <TableCell width={200}><Typography variant="subtitle2" fontWeight="700">Nama Barang</Typography></TableCell>
                                <TableCell><Typography variant="subtitle2" fontWeight="700">Qty</Typography></TableCell>
                                <TableCell><Typography variant="subtitle2" fontWeight="700">Satuan</Typography></TableCell>
                                <TableCell><Typography variant="subtitle2" fontWeight="700">Total</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                          {loading ? (
                            <div style={{ height: '70px' }}>
                              <CircularProgress sx={{ position: 'absolute', left: '45%', marginTop: '10px' }} />
                            </div>
                          ) : (
                            <>
                              {invoiceData.map((row) => {
                                if (row.idpoproduk === 234) {
                                  return (
                                    <TableRow>
                                      <TableCell><Typography variant="subtitle2">{row.no}</Typography></TableCell>
                                      <TableCell><Typography variant="caption">{row.variant}</Typography></TableCell>
                                      <TableCell><Typography variant="subtitle2">{row.jumlah}</Typography></TableCell>
                                      <TableCell><Typography variant="subtitle2">Rp {row.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</Typography></TableCell>
                                      <TableCell><Typography variant="subtitle2">Rp {row.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</Typography></TableCell>
                                    </TableRow>
                                  );
                                } else {
                                  return (
                                    <TableRow>
                                      <TableCell><Typography variant="subtitle2">{row.no}</Typography></TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2">{`${header?.namapo}`}</Typography>
                                        <Typography variant="caption">{row.variant}</Typography>
                                      </TableCell>
                                      <TableCell><Typography variant="subtitle2">{row.jumlah}</Typography></TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2">
                                          Rp {row.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2">
                                          Rp {row.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              })}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item xs={12} sx={{ padding: '22px' }}>
                    <Grid container>
                      
                      <Grid item xs={12} sx={{ paddingY: '2px' }}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" fontWeight="700">Total QTY</Typography>
                          </Grid>
                          <Grid item xs={6} align="right">{totalQty}</Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sx={{ paddingY: '2px' }}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" fontWeight="700">Jumlah</Typography>
                          </Grid>
                          <Grid item xs={6} align="right">Rp {jumlah.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sx={{ paddingY: '2px' }}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" fontWeight="700">Diskon DB {labelDiskon}</Typography>
                          </Grid>
                          <Grid item xs={6} align="right">
                            Rp {Math.ceil(diskon).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sx={{ paddingY: '2px' }}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" fontWeight="700">Total Bayar</Typography>
                          </Grid>
                          <Grid item xs={6} align="right">Rp {totalByr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sx={{ paddingY: '2px' }}>
                        <Grid container>
                          <Grid item xs={8}>
                            <Typography variant="subtitle2" fontWeight="700">Jumlah DP PO 50%</Typography>
                          </Grid>
                          <Grid item xs={4} align="right">Rp {dppo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sx={{ paddingY: '2px' }}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" fontWeight="700">Status PO</Typography>
                          </Grid>
                          <Grid item xs={6} align="right">{poData.status}</Grid>
                        </Grid>
                      </Grid>

                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ paddingY: '22px' }} align="center">
                    <ButtonGroup variant="contained" aria-label="outlined primary button group">
                      {Date.parse(new Date().toISOString().split('T')[0]) < Date.parse(poData.tglselesai) && 
                      poData.status?.toLowerCase() === 'belum dp' &&
                      (
                        <Button
                          disabled={openingModalPo}
                          variant="contained"
                          onClick={() => {
                              setOpeningModalPo(true);
                              setTimeout(() => handleOpenModalPo(poData.idpoproduk), 100);
                          }}
                        >
                            Ubah stok
                        </Button>
                      )}
                      {poData && poData.status?.toLowerCase() === 'belum dp' && (
                        <Button
                          color="secondary"
                          onClick={() => {
                            handleOpenModalPayment();
                          }}
                        >
                          Konfirmasi DP
                        </Button>
                      )}
                      {poData && poData.status?.toLowerCase() === 'sudah confirm dp' && (
                        <Button
                          color="secondary"
                          onClick={() => {
                            handleOpenModalLunas();
                          }}
                        >
                          Konfirmasi Pelunasan
                        </Button>
                      )}
                    </ButtonGroup>
                  </Grid>
                  {Date.parse(new Date().toISOString().split('T')[0]) < Date.parse(poData.tglubah) && 
                  poData.status?.toLowerCase() === 'belum dp' && (
                    <Grid item xs={12} align="center">
                      <Typography variant="subtitle1">
                        <Countdown date={new Date(poData.tglubah)} renderer={renderer} />
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </TabPanel>
              <TabPanel value={valueTab} index={1}>
                <Grid container>
                    <Grid item xs={12}>
                      <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                        <Table stickyHeader aria-label="sticky table" sx={{ minWidth:640 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Nama Barang</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">QTY</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Progres</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Sisa</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Status</Typography></TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {poProgress.length > 0 ? (
                              <>
                                {poProgress.map((row) => (
                                  <TableRow>
                                    {/* Data ini hampir sama seperti admin yang ambil barang po */}
                                    <TableCell>
                                      <Typography variant="subtitle2">{row.no}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="subtitle2">{row.namapo}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="subtitle2">{row.qty}</Typography></TableCell>
                                    <TableCell>
                                      <Typography variant="subtitle2">{row.progresnya}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="subtitle2">{row.sisa}</Typography>
                                    </TableCell>
                                    <TableCell><Typography variant="subtitle2">{row.status}</Typography></TableCell>
                                  </TableRow>
                                ))}
                              </>
                            ) : (
                              <TableRow>
                                <TableCell colSpan="6">
                                  <div style={{ textAlign: 'center', padding: 20 }}>Data kosong</div>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                </Grid>
              </TabPanel>
            </Box>
        </Container>
    )
}

export default PoInvoice
